module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Content #{nr}":"Content #{nr}","Content \\\\#{nr}":"Content \\\\#{nr}"},"de":{"Content #{nr}":"{nr}. Inhalt"}}')
  delete Component.options._Ctor
}
